import { Button, Text } from '@change/ds-core-ui/next';

import { Link } from '@change-corgi/core/react/router';

import { useSapToDm } from './hooks/useSapToDm';

export function SapToDm(): React.JSX.Element {
	const {
		data: { displayName, id, neighborhoodCheckText },
		actions: { trackSapClick },
	} = useSapToDm();

	return (
		<div className="bg-gradient-background-dark-3 text-typography-inverse-strong space-y-6 rounded-xl p-4 text-left md:p-10">
			<Text as="h2" variant="heading">
				Do you have an issue that {displayName} can influence?
			</Text>
			<Text as="p" variant="body">
				{neighborhoodCheckText}Do you have something you want to see change in your community? As one of your elected
				representatives {displayName} may be able to help.
			</Text>
			<div className="flex justify-center md:justify-start">
				<Button
					to={`/start-a-petition?source_location=dm_profile_page&decision_maker_id=${id}`}
					as={Link}
					variant="primary"
					className="whitespace-normal md:w-fit"
					data-qa="dm-sap-cta-button"
					onClick={trackSapClick}
				>
					Start a petition to {displayName}
				</Button>
			</div>
		</div>
	);
}
